import { configureStore } from "@reduxjs/toolkit";
import bandwidthReducer from './Bandwidthslice.js'

const store=configureStore({
    reducer:{
        bandwidth:bandwidthReducer,

    }
})
export default store;